import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-over-under',
    templateUrl: './default/over-under/over-under.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class OverUnderComponent extends UnitsDistributionBase {
  // Used for FOOTBALL_OVER_UNDER
  // Note: This component is conditionally used based on isSepPool
  // When isSepPool is true, ud-sep-default is used instead
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}